import { createI18n } from 'vue-i18n'
import cache from '@/utils/cache'

// element-plus 国际化文件
import element_zh_cn from 'element-plus/lib/locale/lang/zh-cn'
import element_en from 'element-plus/lib/locale/lang/en'
import element_es from 'element-plus/lib/locale/lang/es'
import element_ar from 'element-plus/lib/locale/lang/ar'
import element_ru from 'element-plus/lib/locale/lang/ru'
import element_fr from 'element-plus/lib/locale/lang/fr'

// 框架 国际化文件
const zh_cn = import.meta.globEager('./lang/**/zh-CN.ts') // 中
const en_us = import.meta.globEager('./lang/**/en-US.ts') // 英
const es_es = import.meta.globEager('./lang/**/es-ES.ts') // 西班牙
const ar_ar = import.meta.globEager('./lang/**/ar-AR.ts') // 阿拉伯
const ru_ru = import.meta.globEager('./lang/**/ru-RU.ts') // 俄语
const fr_fr = import.meta.globEager('./lang/**/fr-FR.ts') // 法语

// 加载 lang 文件夹下的国际化
export const loadLang = (modules: Record<string, any>) => {
	const messages: { [key: string]: string } = {}

	Object.keys(modules).forEach(module => {
		Object.assign(messages, { ...modules[module].default })
	})
	return messages
}

export const messages: { [key: string]: any } = {
	'en-US': {
		langName: 'English',
		...loadLang(en_us),
		el: {
			...element_en
		}
	},
	'zh-CN': {
		langName: '简体中文',
		...loadLang(zh_cn),
		el: {
			...element_zh_cn
		}
	},
	// 'es-ES': {
	// 	langName: 'España',
	// 	...loadLang(es_es),
	// 	el: {
	// 		...element_es
	// 	}
	// },
	// 'ar-AR': {
	// 	langName: 'بالعربية',
	// 	...loadLang(ar_ar),
	// 	el: {
	// 		...element_ar
	// 	}
	// },
	// 'ru-RU': {
	// 	langName: 'Русский язык',
	// 	...loadLang(ru_ru),
	// 	el: {
	// 		...element_ru
	// 	}
	// },
	// 'fr-FR': {
	// 	langName: 'Français',
	// 	...loadLang(fr_fr),
	// 	el: {
	// 		...element_fr
	// 	}
	// }
}

// 返回当前 Language
function getLanguage() {
	return cache.getLanguage()
}

export const i18n = createI18n({
	locale: getLanguage(),
	legacy: false,
	globalInjection: true,
	messages
})
